import template from './ptzModal.html';

/* @ngInject */
function PTZModalController($q, $timeout, CameraService, PTZControlsService, growl) {
  const vm = this;

  vm.showPopover = false;
  vm.showOverlays = true;
  vm.popoverCircles = {
    text1: 'Single-click one of the arrows and move the mouse to rotate the dial, ' +
      'then click again away from the arrow to adjust the camera\'s tilt and pan degrees',
    text2: ''
  };
  vm.popoverGrid = {
    text1: 'Click or touch the image to move the PTZ to that location.',
    text2: 'Click or touch and drag to move and zoom the ptz to fit the contents of the rectangle'
  };

  vm.lookingAtGrid = true;
  vm.loadingsSpinners = false;

  vm.$onInit = () => {
    _.assign(vm, vm.resolve);

    vm.camera = angular.copy(CameraService.getCamera(vm.panel.id, vm.cameraId));

    $q.all([
      PTZControlsService.getPTZInfo(vm.cameraId),
      PTZControlsService.getPTZLimits(vm.cameraId),
      CameraService.getRotation(vm.cameraId)
    ])
      .then(([info, limits, { data: rotData }]) => {
        vm.ptzInfo = info;
        vm.ptzLimits = limits;
        vm.rotation = rotData.rotation;
      })
      .catch(({ error }) => {
        growl.info(`PTZ information could not be retrieved: ${error}`);
        vm.dismiss();
      })
      .finally(vm.rendered)
      .then(() => {
        vm.loadingSpinners = true;
      });
  };

  vm.alterPtz = (params) => {
    const PTZ_TIMEOUT = 5000;
    PTZControlsService.alterPTZ(vm.cameraId, params)
      .then(() => {
        setTimeout(() => {
          PTZControlsService.getPTZInfo(vm.cameraId)
            .then((info) => {
              vm.ptzInfo = info;
            });
        }, PTZ_TIMEOUT);
      });
  };

  vm.moveCameraAbsolute = (pan, tilt) => {
    const coords = {
      pan,
      tilt
    };
    PTZControlsService.absolutePositionPTZ(vm.cameraId, coords)
      .then(() => {
        coords.zoom = vm.ptzInfo.zoom;
        vm.ptzInfo = coords;
      });
  };

  vm.resetCrosshair = () => {
    $timeout(() => { // TODO: GET RID OF THIS!!! After changing backend to only respond once pan and tilt have changed
      PTZControlsService.getPTZInfo(vm.cameraId)
        .then((info) => {
          vm.ptzInfo = info;
        });
    }, 1000);
  };

  vm.changeSvg = () => {
    if (vm.lookingAtGrid) {
      $('ptz-circles').removeClass('animated fadeIn');
    }
    vm.lookingAtGrid = !vm.lookingAtGrid;
  };

  vm.showMe = (el) => {
    if (el === 'circlesGuide') {
      return vm.showPopover && !vm.lookingAtGrid;
    } else if (el === 'gridGuide') {
      return vm.showPopover && vm.lookingAtGrid;
    } else if (el === 'ptzCircles') {
      return vm.loadingSpinners && vm.showOverlays && _.has(vm, 'ptzInfo.pan') && !vm.lookingAtGrid;
    } else if (el === 'ptzGrid') {
      return vm.loadingSpinners && vm.showOverlays && _.has(vm, 'ptzInfo.pan') && vm.lookingAtGrid;
    } else if (el === 'sub') {
      return _.has(vm, 'ptzInfo.zoom');
    }
    return true;
  };

  vm.toggleOverlayAction = (show) => {
    vm.showOverlays = show;
  };
}

export default {
  name: 'ptzModalComponent',
  template,
  controller: PTZModalController,
  controllerAs: 'PTZModalCtrl',
  bindings: {
    dismiss: '&',
    rendered: '&',
    resolve: '<'
  }
};
